import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import axios from 'axios';
import  {useState } from "react";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Forgot from "./Forgot";
import {API_URL} from './config';
import logo from './assets/logo_grey.svg';
import {useNavigate} from "react-router-dom";
import { useDispatch } from 'react-redux';
import Footer from "./components/Footer";



const theme = createTheme();

export default function Login(props) {
    const dispatch = useDispatch();

    const [loginForm, setLoginform] = useState({
        username: "",
        password: "",
    });

    const [clickedForgot, setClickedForgot] = useState(false); // clickedForgot durumu eklenmiştir
    const [path, setPath] = useState("login");
    let navigate= useNavigate();

    const onChangeForm = (label, event) => {
        switch (label) {
            case "username":
                setLoginform({ ...loginForm, username: event.target.value });
                break;
            case "password":
                setLoginform({ ...loginForm, password: event.target.value });
                break;
        }
    };

    const handleChange = (event) => {
        setLoginform(event.target.loginForm);
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

// data.append('username','merve')
// data.append('password','12345')

        // call api login


        console.log(data)
         await axios.post(`${API_URL}/auth/token`,data).then(async(response) => {
            console.log("RESPONSE DATAAAA",response.data);
            const accessToken = response.data.access_token;
            const tokenExpiry = response.data.exp;
            console.log("Demo Auth token:", accessToken);
            console.log("tokenExpiry:", tokenExpiry);
            await localStorage.setItem("ac_auth_token", JSON.stringify(response.data.access_token));
            await localStorage.setItem("ac_token_expiry", JSON.stringify(tokenExpiry));
            await localStorage.setItem("ac_name", JSON.stringify(response.data.name));
            await localStorage.setItem("ac_department", JSON.stringify(response.data.department));
            await localStorage.setItem("ac_permissions", JSON.stringify(response.data.permissions));
            await localStorage.setItem("ac_id", JSON.stringify(response.data.doctor_id));

            //bilgilendirme mesajı
            toast.success(response.data.detail);

            //token doğru ise sayfa yönlendirmesi yap
            setTimeout(() => {
              window.location.href="/doctor/dashboard";
            }, 1000);


        }) .catch(error => {
            console.log(error);
            //error mesajı
            toast.error('Kullanıcı doğrulaması yapılamadı. Eposta veya şifre yanlış olabilir.',error.response.data.detail);

        });

    };

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Container component="main" maxWidth="xs" style={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'left',

            }}>

                <Box
                    sx={{
                        marginTop: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <a href={'/'}>
                        <img width={'80%'} src={logo}/>
                    </a>

                    <br/>
                    <Typography component="h1" variant="h5" textAlign={'center'}>
                          Giriş Yap
                    </Typography>

                    <Box component="form" onSubmit={handleSubmit} onChange={handleChange} noValidate sx={{mt: 1}}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="username"
                            label="Eposta Adresi"
                            name="username"
                            autoComplete="username"
                            autoFocus
                            onChange={(event) => {
                                onChangeForm("username", event);
                            }}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Şifre"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            onChange={(event) => {
                                onChangeForm("password", event);
                            }}
                        />
                        {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Beni Hatırla"
              onChange={handleChange}
            /> */}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{mt: 3, mb: 2}}
                            color="primary"
                            onSubmit={handleSubmit}
                        >
                            Giriş
                        </Button>


                        <a href={'/forgot-password'}>Şifremi Unuttum</a>
                        <br/>
                        <br/>
                        <a href={'/register'}>Hesabınız yok mu? Kayıt olun</a>

                    </Box>
                </Box>
                <Footer/>

            </Container>


        </ThemeProvider>
    );
}
